import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { COLORS } from 'parameters'
import { FionaLogo } from 'components/patterns/icons'
import { AffiliateLink } from 'components/elements/AffiliateLink'

interface Props {
	partnerLogo?: string
	partnershipText?: string
	partnerUrl?: string
	headerStyle: 'fiona_cobrand' | 'partner_cobrand' | 'fiona_only' | 'partner_only'
}

const AffiliateHeader: React.FC<React.PropsWithChildren<Props>> = ({
	partnerLogo,
	headerStyle,
	partnershipText,
	partnerUrl
}): JSX.Element => {
	let leftLogo: JSX.Element | null = null
	let rightLogo: JSX.Element | null = null
	let partnershipElement: JSX.Element | null = null

	const partnerLogoElement: JSX.Element | null = partnerLogo ? (
		<AffiliateLink href={partnerUrl || '#'} openInNewWindow={true}>
			{/* disable next line is added to ignore @next/next/no-img-element error */}
			{/* eslint-disable-next-line */}
			<img className={'logo'} src={partnerLogo} alt={'Logo'} />
		</AffiliateLink>
	) : null
	const fionaLogo = (
		<Link href={'/'} legacyBehavior>
			<FionaLogo style={{ maxHeight: '40px', display: 'flex', flexShrink: 1, cursor: 'pointer' }} />
		</Link>
	)
	if (partnershipText && partnershipText.length > 1) {
		partnershipElement = <PartnerText>{partnershipText}</PartnerText>
	}
	switch (headerStyle) {
		case 'partner_cobrand':
			leftLogo = partnerLogoElement
			rightLogo = (
				<InnerContent>
					{partnershipElement}
					{fionaLogo}
				</InnerContent>
			)
			break
		case 'fiona_only':
			leftLogo = fionaLogo
			break
	}

	return (
		<>
			<Wrapper>
				<Content>
					{leftLogo}
					{rightLogo}
				</Content>
			</Wrapper>
			<HeaderShim />
		</>
	)
}

export default AffiliateHeader

const HeaderShim = styled.div`
	height: 60px;
`

const PartnerText = styled.p`
	line-height: 0.9;
	font-size: 0.9rem;
	margin-bottom: 3px;
`

const Wrapper = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	height: 60px;
	width: 100%;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	z-index: 100;
	background-color: ${COLORS.WHITE};
`
const InnerContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;

	> img {
		align-self: flex-end;
	}
`

const Content = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 11px 16px;
	height: 65px;
	max-width: 1366px;
	margin: 0 auto;
	.logo {
		max-height: 60px;
		max-width: 200px;
	}
	.leftImage {
		width: 80px;
	}
	.rightImage {
		width: 80px;
	}
	a {
		display: flex;
		align-items: center;
	}
`
